<template>
  <div class="home-page">
    <GlobalHeader is-home-page />
    <main class="main-content">
      <HomeHero />
      <HomeAnnouncementList />
      <ul class="service-card">
        <li v-for="service in serviceData" :key="service.id">
          <img :src="service.icon" alt="" class="icon" />
          <span class="service-title">{{ service.title }}</span>
        </li>
      </ul>
      <HomeBottomSection />
    </main>
    <GlobalFooter />
    <!-- <div class="qr-code-con">
      <img src="@/assets/homeImages/qr-code.png" alt="">
      <p>注册报名请关注官方公众号，了解更多资讯</p>
    </div> -->
  </div>
</template>

<script>
import HomeHero from './components/HomeHero.vue';
import HomeAnnouncementList from './components/HomeAnnouncementList.vue';
import HomeBottomSection from './components/HomeBottomSection.vue';
import GlobalFooter from '@/components/GlobalFooter.vue';
import GlobalHeader from '@/components/GlobalHeader.vue';
const serviceData = [
  { id: 1, title: '招标信息推送', icon: require('@/assets/homeImages/home-service01.png') },
  { id: 2, title: '标书代写', icon: require('@/assets/homeImages/home-service02.png') },
  { id: 3, title: '投标需求咨询', icon: require('@/assets/homeImages/home-service03.png') },
  { id: 4, title: '中标数据统计', icon: require('@/assets/homeImages/home-service04.png') },
  { id: 5, title: '法律法规学习平台', icon: require('@/assets/homeImages/home-service05.png') }
]
export default {
  name: 'Home',
  components: {
    GlobalHeader,
    HomeHero,
    HomeAnnouncementList,
    HomeBottomSection,
    GlobalFooter,
  },
  data() {
    return {
      serviceData,
    };
  },
};
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  color: #1e293b; // text-slate-800

  .main-content {
    flex-grow: 1;
  }

  .qr-code-con {
    position: fixed;
    top: 112px;
    right: 32px;
    width: 148px;

    img {
      width: 148px;
      height: 148px;
    }

    p {
      font-size: 13px;
      color: #212227;
      margin-top: 8px;
      text-align: center;
    }
  }

  .service-card {
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 90px;

    li {
      width: 212px;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 4px 16px 0px #5772C314;
      background: #FFFFFF;
      border-radius: 8px;
      cursor: pointer;

      img {
        width: 48px;
        height: 48px;
      }

      .service-title {
        font-size: 17px;
        color: #27282F;
        margin-left: 16px;
      }
    }
  }
}
</style>
